import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';

function Navigation({ navigateToAnchor }) {
    const goAnchor = (e, anchor) => {
        e.preventDefault();
        if (navigateToAnchor) navigateToAnchor(anchor);
    };
    const goTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <Navbar expand="lg" className="bg-transparent site-nav">
            <Container>
                <Navbar.Brand href="#" onClick={goTop} className="d-flex align-items-center brand">
                    <img
                        src={`${process.env.PUBLIC_URL || ''}/srl-advisor-logo-192.png`}
                        alt=""
                        className="brand-logo"
                        height={36}
                    />
                    <span className="brand-name">SRL Advisor</span>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="srl-navbar" />
                <Navbar.Collapse id="srl-navbar">
                    <Nav className="ms-auto align-items-lg-center">
                        <Nav.Link href="#how" onClick={(e) => goAnchor(e, 'how')}>How it works</Nav.Link>
                        <Nav.Link href="#research" onClick={(e) => goAnchor(e, 'research')}>Research</Nav.Link>
                        <Nav.Link href="#roadmap" onClick={(e) => goAnchor(e, 'roadmap')}>Roadmap</Nav.Link>
                        <Nav.Link href="#institutions" onClick={(e) => goAnchor(e, 'institutions')}>For institutions</Nav.Link>
                        <Nav.Link href="#about" onClick={(e) => goAnchor(e, 'about')}>About</Nav.Link>
                        <a
                            href="#contact"
                            onClick={(e) => goAnchor(e, 'contact')}
                            className="btn-nav-cta ms-lg-3 mt-2 mt-lg-0"
                        >
                            Get in touch
                        </a>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Navigation;
